import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import Fuse from 'fuse.js';

import MkaDetectionsTable from '../components/MkaDetectionsTable';
import MkaDetectionsModel from '../components/MkaDetectionsModel';

import ParkinglocationSelect from '../components/ParkinglocationSelect';

import { Layout, Button, Row, Col, Input, Icon, message, DatePicker } from 'antd';

import 'moment/locale/cs';

class AutoDetectionsScreen extends Component {

  fuseOptions = {
    shouldSort: true,
    includeScore: true,
    threshold: 0.1,
    location: 0,
    distance: 100,
    maxPatternLength: 32,
    minMatchCharLength: 2,
    keys: [
      "plate"
    ]
  };

  state = {
    dataLoading: true,
    dataAll: [],
    data: [],
    parkinglocation: null,
    dateFrom: moment().startOf('day'),
    dateTo: moment().endOf('day')
  }

  componentDidMount() {
    this.loadData(this.state.parkinglocation, this.state.dateFrom, this.state.dateTo);
  }

  loadData(parkinglocation = null, dateFrom = null, dateTo = null) {
    dateFrom = dateFrom ? dateFrom.format() : null;
    dateTo = dateTo ? dateTo.format() : null;
    this.setState({
      dataLoading: true,
      dataAll: [],
      data: []
    });
    MkaDetectionsModel.getAll(
      parkinglocation,
      dateFrom,
      dateTo
    )
      .then(data => {
        this.setState({
          dataLoading: false,
          dataAll: data,
          data: data
        });
      })
      .catch(err => {
        message.warning('Data se nepodařilo načíst. Zkontrolujte spravnou funkčnost služby.')
        this.setState({
          dataLoading: false,
        });
      });
  }

  onSearch(searchText) {
    const dataAll = this.state.dataAll;
    this.setState({
      dataLoading: true
    })
    if (searchText) {
      let fuse = new Fuse(dataAll, this.fuseOptions);
      let results = fuse.search(searchText);
      results = results.map((result) => {
        return result.item;
      });
      this.setState({
        dataLoading: false,
        data: results
      });
    } else {
      this.setState({
        dataLoading: false,
        data: dataAll
      });
    }
  }

  onDateRangeChanged(dates, dateStrings) {
    this.setState({
      dateFrom: dates[0],
      dateTo: dates[1]
    });
    this.loadData(this.state.parkinglocation, dates[0], dates[1]);
  }

  render() {
    return (
      <Layout.Content style={{ margin: '24px 16px 0' }}>
        <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
          <h2>MKA - Detekované RZ</h2>
          <div style={{ marginBottom: '20px' }}>
            <Row>
              <Col span={22}>
                <ParkinglocationSelect
                  onChange={(value) => {
                    this.setState({ parkinglocation: value });
                    this.loadData(value, this.state.dateFrom, this.state.dateTo);
                  }}
                  style={{ width: 300 }} />
                {' '}
                <DatePicker.RangePicker
                  defaultValue={[
                    this.state.dateFrom,
                    this.state.dateTo
                  ]}
                  locale={{
                    timePickerLocale: { placeholder: 'Vybrat čas' }
                  }}
                  ranges={{
                    "Dnes": [moment().startOf('day'), moment().endOf('day')],
                    "Včera": [moment().add(-1, 'days').startOf('day'), moment().add(-1, 'days').endOf('day')],
                    "Poslední týden": [moment().add(-7, 'days').startOf('day'), moment().endOf('day')],
                  }}
                  allowClear={false}
                  placeholder={['Od', 'Do']}
                  format="DD.MM.YYYY HH:mm"
                  showTime={{ format: 'HH:mm' }}
                  onOk={this.onDateRangeChanged.bind(this)} 
                  style={{ width: 300 }} />
                {' '}
                <Input.Search
                  placeholder="Hledat RZ"
                  onSearch={this.onSearch.bind(this)}
                  style={{ width: 300 }} />
              </Col>
              <Col span={2} offset={0} style={{ textAlign: 'right' }}>
                <Button type="default" onClick={() => { this.loadData(this.state.parkinglocation, this.state.dateFrom, this.state.dateTo) }} >
                  <Icon type="sync" />
                </Button>
              </Col>
            </Row>
          </div>
          <MkaDetectionsTable
            data={this.state.data}
            loading={this.state.dataLoading}
            onRemoveRow={(id) => {
              MkaDetectionsModel.remove(id)
                .then(() => {
                  this.loadData(this.state.parkinglocation, this.state.dateFrom, this.state.dateTo);
                });
            }} />
          <p style={{ fontSize: 12, fontStyle: 'italic' }}>
            <b>Probíhá kontrola</b> - zatím nejsou známy výsledky kontroly<br />
            <b>Částečná shoda</b> - shoda ve 4 koncových znacích detekované RZ<br />
            <b>Možný přestupek</b> - RZ ani její část nemá platné PO<br />
            Kliknutím na stav kontroly zobrazíte nalezená PO
          </p>
        </div>
      </Layout.Content>
    );
  }
}

export default AutoDetectionsScreen;



// WEBPACK FOOTER //
// ./src/screens/MkaDetectionsScreen.js